import { memo } from 'react'
import classNames from 'classnames'
import { FavoriteButton } from '@dustin-web/product-components/src/product-add-to-favorites/favorites-button'
import { CompareButton } from '@dustin-web/product-components/src/product-compare/product-compare'
import type { ProductPageType } from '../../'

import './product-utility-bar.scss'

type Props = {
  product: ProductPageType
  isSmallScreen: boolean
}

const ProductUtilityBar = ({ product, isSmallScreen }: Props) => {
  return (
    <section className={classNames('product-utility-bar', { mobile: isSmallScreen })}>
      {product.category?.name && (
        <CompareButton
          listForm={!isSmallScreen}
          withBorder={isSmallScreen}
          productId={product.id}
          displayName={product.displayName}
          categoryName={product.category?.name}
        />
      )}
      <FavoriteButton
        withBorder={isSmallScreen}
        digitalDataOrigin={'productPage'}
        product={product}
      />
    </section>
  )
}

export default memo(ProductUtilityBar)
